import Swiper from 'swiper';
import {Pagination, Keyboard, A11y} from 'swiper/modules';

new Swiper('.swiper-reviews', {
// configure Swiper to use modules
  modules: [Pagination, Keyboard, A11y],
  slidesPerView: 1,
  spaceBetween: 30,
  keyboard: {
    enabled: true,
  },

  pagination: {
    enabled: true,
    el: '.swiper-pagination-customer-reviews',
    clickable: true,
  },
});
